enum DistributionTypes {
    TDS = 0,
    Email = 1,
    SMS = 2
}

export default DistributionTypes;